
import { COUNTRY_LIST, STATE_LIST, CITY_LIST, ID_LIST, PROFESSION_LIST, CATEGORY_LIST, HOBBY_LIST } from './constants';
import { getPublicIP, getAuthHeader , setJWTToken, setUserInSession } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse , loader } from './utils';

export const countryList = (countryList) => {
  
    return {
      type: COUNTRY_LIST,
      countryList
    }; 
};

export const stateList = (stateList) => {
    return {
      type: STATE_LIST,
      stateList
    }; 
};

export const cityList = (cityList) => {
    return {
      type: CITY_LIST,
      cityList
    }; 
};

export const idtypeList = (idList) => {
  return {
    type: ID_LIST,
    idList
  }; 
};

export const professionList = (professionList) => {
  return {
    type: PROFESSION_LIST,
    professionList
  }; 
};

export const categoryList = (categoryList) => {
  return {
    type: CATEGORY_LIST,
    categoryList
  }; 
};

export const hobbyList = (hobbyList) => {
  return {
    type: HOBBY_LIST,
    hobbyList
  }; 
};

/*
 Name         : fetchCountryList
 Description  : Country List
*/ 
export const fetchCountryList = () => {
    return (dispatch, getState) => {
          
        const headers = getAuthHeader();
        postReq(`${apiURLPrefix}/common/list_country`, null , headers)
        .then(handleResponse)
        .then((res) => {
          res.unshift(
            { country_code: "ALL",
              country_dial_code: "ALL",
              country_flag_code: "",
              country_name: headers.Language == 'en' ? "ALL" : "Dhamman",
              id: "ALL",
              status: "1"}
          );
          dispatch(countryList(res));
        }).catch((err)=>{
          console.log(err)
        }) 
    }  
};

/*
 Name         : fetchStateList
 Description  : State List
*/ 
export const fetchStateList = (params) => {
    return (dispatch, getState) => {
        const bodyFormData = new FormData();
        bodyFormData.set('country_id', params);  
        const headers = getAuthHeader();
        postReq(`${apiURLPrefix}/common/list_state`, bodyFormData , headers)
        .then(handleResponse)
        .then((res) => {
          dispatch(stateList(res));
        }).catch((err)=>{
          console.log(err)
        }) 
    }  
};

/*
 Name         : fetchCityList
 Description  : City List
*/ 
export const fetchCityList = (params) => {
    return (dispatch, getState) => {
        const bodyFormData = new FormData();
        bodyFormData.set('state_id', params);  
        const headers = getAuthHeader();
        postReq(`${apiURLPrefix}/common/list_city`, bodyFormData , headers)
        .then(handleResponse)
        .then((res) => {
          dispatch(cityList(res));
        }).catch((err)=>{
          console.log(err)
        }) 
    }  
};

/*
 Name         : fetchProfileIDList
 Description  : ID List
*/ 
export const fetchProfileIDList = (params) => {
  return (dispatch, getState) => {
      const bodyFormData = new FormData();
      bodyFormData.set('goldenspace_category', 'ID TYPE');  
      bodyFormData.set('country_id', params);  
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/common/category_goldenspace`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
        dispatch(idtypeList(res));
      }).catch((err)=>{
        console.log(err)
      }) 
  }  
};

/*
 Name         : fetchProfileProfessionList
 Description  : Profession List
*/ 
export const fetchProfileProfessionList = (params) => {
  return (dispatch, getState) => {
      const bodyFormData = new FormData();
      bodyFormData.set('goldenspace_category', 'WORK TITLE');  
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/common/category_goldenspace`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
        dispatch(professionList(res));
      }).catch((err)=>{
        console.log(err)
      }) 
  }  
};

/*
 Name         : fetchProfileProfessionList
 Description  : Profession List
*/ 
export const fetchCategoryList = (params) => {
  return (dispatch, getState) => {
      const bodyFormData = new FormData();
      bodyFormData.set('goldenspace_category', params);  
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/common/category_goldenspace`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
        res.unshift(
          { category_image: null,
            category_name: headers.Language == 'en' ? "ALL" : "Dhamman",
            category_type: "PROFESSION",
            category_url: null,
            id: 0,
            is_select: "0",
            parent_category_id: null}
        );
        dispatch(categoryList(res));
      }).catch((err)=>{
        console.log(err)
      }) 
  }  
};

/*
 Name         : fetchHobbyList
 Description  : Hobby List
*/ 
export const fetchHobbyList = (params) => {
  return (dispatch, getState) => {
      const bodyFormData = new FormData();
      bodyFormData.set('goldenspace_category', 'HOBBY');  
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/common/category_goldenspace`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
        res.unshift(
          { category_image: null,
            category_name: headers.Language == 'en' ? "ALL" : "Dhamman",
            category_type: "HOBBY",
            category_url: null,
            id: 0,
            is_select: "0",
            parent_category_id: null}
        );
        dispatch(hobbyList(res));
      }).catch((err)=>{
        console.log(err)
      }) 
  }  
};